import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listJuzgados:[],
  ListMaterias:[],
};
export const mutations = {
  GET_JUZGADOS({ context }, listJuzgado) {
    state.loading = false;
    if (listJuzgado) {
      let juzgados = [];
      Object.entries(listJuzgado).forEach(([key, val]) => juzgados.push(val));
      return (state.listJuzgados = juzgados);
    }
  },
  GET_MATERIAS({ context }, listMateria) {
    state.loading = false;
    if (listMateria) {
      let materias = [];
      Object.entries(listMateria).forEach(([key, val]) => materias.push(val));
      return (state.ListMaterias = materias);
    }
  },
  SAVE_JUZGADO({ context }, juzgado) {
    state.newJuzgado = Object.assign({}, juzgado);
  },
  EDIT_JUZGADO({ context }, data) {
    state.dataJuzgado = Object.assign({}, data);
  },
};
export const actions = {
  GET_JUZGADOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_JUZGADOS", response.data.data.juzgados);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_JUZGADOS_SELECT({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_JUZGADOS", response.data.data.juzgados);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_JUZGADOS_BY_PARTIDO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
      .then(response => {
        commit("SET_LOADING", false);
        commit("GET_JUZGADOS", response.data.data.juzgados);//mandar a mutations
        resolve(response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        reject(error);
      });
    });
  },
  GET_JUZGADOS_BY_ZONA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
      .then(response => {
        commit("SET_LOADING", false);
        commit("GET_JUZGADOS", response.data.data.juzgados);//mandar a mutations
        resolve(response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        reject(error);
      });
    });
  },
  GET_MATERIAS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_MATERIAS", response.data.data.materias);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_JUZGADO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_JUZGADO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_JUZGADO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_JUZGADO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_JUZGADO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  };

export const getters = {//leer datos
  listJuzgados: state => state.listJuzgados,
  ListaJuzgadosActivos: (state, getters, store) => {
    let listaJuzgadosCompleta = getters.listJuzgados;
    let listActivos = listaJuzgadosCompleta.filter( function(juzgado) {
         return juzgado.deleted_at == null;
       });
    return listActivos;
  },
  ListMaterias: state => state.ListMaterias,
};
